export default __webpack_public_path__ + "static/media/wait_icon.7b6232b7.svg";